import { defineStore } from 'pinia';
import axios, { AxiosResponse } from 'axios';
import VLApi from '@/api/VLApi';

//Import other pinia stores
import { useWebportalStore } from './webportal';
import { useFeedbackStore } from './feedback';

//Import models
import { LaundryItem } from '@/models/LaundryItem';
import { ContactHTMLItem } from '@/models/ContactHTMLItem';
import { FAQHTMLItem } from '@/models/FAQHTMLItem';
import { WasserijKlant } from '@/models/WasserijKlantItem';
import { KlantenserviceEmailItem } from '@/models/KlantenserviceEmailItem';
import servicesAPI from '@/api/servicesAPI';

//Setup store
export const useLaundryStore = defineStore('laundry', {
    state: () => ({
        currentLaundry: JSON.parse(localStorage.getItem('laundry') || 'null') as LaundryItem,
        contactHTML: {} as ContactHTMLItem | undefined,
        FAQHTML: [] as FAQHTMLItem[],
        klant: {} as WasserijKlant
    }),
    actions: {
        //Get current laundry using basic auth token
        async getLaundry(){
            try{
                const response = await VLApi.get(`${useWebportalStore().vlApiUrl}/klant/wasserijInfo`);
                this.currentLaundry = response.data.data as LaundryItem;
                localStorage.setItem('laundry', JSON.stringify(this.currentLaundry));
            }
            catch (error){
                console.error(error);

                // Try to get wasserij info from webportal service.
                // TODO: Can be removed when all laundries with a webportal have been updated.
                if (useWebportalStore().selectedWebportal?.ServiceUrl) {
                    try {
                        const response = await servicesAPI.post(`${useWebportalStore().selectedWebportal.ServiceUrl}/GetWasserijInfo`, {})
                        this.currentLaundry = response.data.d as LaundryItem;
                        localStorage.setItem('laundry', JSON.stringify(this.currentLaundry));
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        },

        //Get HTML for contact page from laundry's contact url
        async getContactHTML(){
            //If no contact url is available cancel
            if(!this.currentLaundry.contactURL){
                return;
            }

            //Execute api call
            const feedbackStore = useFeedbackStore();
            feedbackStore.startLoading();
            try{
                const response = await axios.get(this.currentLaundry.contactURL);
                const list = response.data as ContactHTMLItem[];
                this.contactHTML = list.find(item => item.name === 'contact');
            }
            catch (error) {
                console.error(error);
                feedbackStore.stopLoading();
                return;
            }
            feedbackStore.stopLoading();
        },

        //Get HTML for contact page from laundry's contact url
        async getFAQHTML(){
            //If no contact url is available cancel
            if(!this.currentLaundry.faqurl){
                return;
            }

            //Execute api call
            const feedbackStore = useFeedbackStore();
            feedbackStore.startLoading();
            try{
                const response = await axios.get(this.currentLaundry.faqurl);
                this.FAQHTML = response.data as FAQHTMLItem[];
            }
            catch (error) {
                console.error(error);
                feedbackStore.stopLoading();
                return;
            }
            feedbackStore.stopLoading();
        },

        async getKlant() {
            try {
                const response = await VLApi.get(`${useWebportalStore().vlApiUrl}/klant`);
                this.klant = response.data.data as WasserijKlant;
                return this.klant;
            } catch (error) {
                console.error(error);
                return null;
            }
        },

        async sendKlantenserviceEmail(emailItem: KlantenserviceEmailItem): Promise<AxiosResponse<any, any>> {
            const response = await VLApi.post(`${useWebportalStore().vlApiUrl}/webportal/klantservice/send`, emailItem);
            return response;
          },
    },
})